// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1S2oS","clinicsSelect":"TableHeading_clinicsSelect__9Nlsm"};